import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
	static targets = ["source", "copy", "hp", "highLevelHpBonus", "xp", "ba", "jp"];
	static values = { templates: Object };

	connect() {
		this.toggleCopyButton();
	}

	toggleCopyButton() {
		this.copyTarget.disabled = !this.selectedTemplate;
	}

	copy() {
		const template = this.selectedTemplate;
		if (!template) return;

		this.fill(this.hpTarget, template.hp);
		this.fill(this.highLevelHpBonusTarget, template.high_level_hp_bonus);
		this.fillAll(this.xpTargets, template.xp_progression);
		this.fillAll(this.baTargets, template.ba_progression);
		this.fillAll(this.jpTargets, template.jp_progression);
	}

	get selectedTemplate() {
		return this.templatesValue[this.sourceTarget.value];
	}

	fillAll(targets, values) {
		targets.forEach((target, index) => {
			this.fill(target, values[index]);
		});
	}

	fill(target, value) {
		target.value = value;
		target.dispatchEvent(new Event("input", { bubbles: true }));
	}
}
